
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-back",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-back"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('g',{staticClass:"cog-i-chevron"},[_c('path',{attrs:{"stroke-linecap":"square","d":"M11.18 3.59L5.77 9l5.42 5.42"}})])])])
          )
        }
      }
    